export default [
  {
    title: "Reports",
    icon: "MonitorIcon",
    tagVariant: "light-warning",
    children: [
      {
        title: "Paid Transaction",
        route: "PaidTransaction-View",
        resource: "Report",
        action: "PaidTransaction",
      },
      {
        title: "Market Share Report",
        route: "MarketShareReport-View",
        resource: "Report",
        action: "MarketShareReport",
      },
      {
        title: "Success Rate",
        icon: "MonitorIcon",
        children: [
          {
            title: "Payment",
            route: "PaymentSuccessRate-View",
            resource: "Report",
            action: "PaymentSuccessRate",
          },
          {
            title: "Refund",
            route: "RefundSuccessRate-View",
            resource: "Report",
            action: "RefundSuccessRate",
          },
        ],
      },
      {
        title: "Transaction Trend",
        route: "TransactionalReport-View",
        resource: "Report",
        action: "TransactionalReport",
      },
      {
        title: "Merchants Report",
        route: "MerchantsReport-View",
        resource: "Report",
        action: "MerchantsReport",
      },
      {
        title: "Overall Transaction",
        icon: "MonitorIcon",
        children: [
          {
            title: "Payment",
            route: "PaymentOverallTransaction-Report",
            resource: "Report",
            action: "PaymentOverallTransaction",
          },
          {
            title: "Refund",
            route: "RefundOverallTransaction-Report",
            resource: "Report",
            action: "RefundOverallTransaction",
          },
        ],
      },
      {
        title: "Net Summery Report",
        route: "NetSummeryReport-View",
        resource: "Report",
        action: "NetSummeryReport",
      },
      {
        title: "Performance Report",
        route: "PerformanceReport-View",
        resource: "Report",
        action: "PerformanceReport",
      },
    ],
  },
];
